import $ from 'jquery';
import BaseClass from './BaseClass';
import Util from '../util/Util';

/**
 * スクロール位置を起因とするアニメーション実行の基礎クラス
 * @param {String} _target 対象となるクラス名やid名
 */
export default class SectionBaseClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'SectionBaseClass';

    this._target = _target;
    this.isStart = false;
    this.isLoad = false;
    this.isActive = false;
    this.target = null;
    this.offset = {
      top: 0, bottom: 0,
    };
    this.htmlLast = 0;
    this.scrollTop = 0;
    this.isInsertActive = true;
  }

  onCreate() {
    super.onCreate();
    this.target = (typeof this._target == 'string') ? $(this._target) : this._target;

    this.isModalIn = (this.target.closest('.modal').length > 0);
  }

  onLoad() {
    super.onLoad();
    this.isLoad = true;
  }

  onStop() {
    super.onStop();
    this.isLoad = false;
  }

  onRemove() {
    super.onRemove();
    this.isStart = false;
    this.isActive = false;
    this.target = null;
  }

  onResize(_size) {
    super.onResize();
    if (!this.target || (Util.isSpModalOpen && !this.isModalIn) || this.target.is(':hidden')) { return; }
    let s = (Util.isBreakpoint) ? 6 : 4;
    let wh2 = _size.h - _size.h / s;
    let offset = $.extend({}, this.target.offset());
    let top = Math.floor(offset.top);
    let bottom = Math.floor(top + this.target.outerHeight(true) * 0.8);
    this.offset = { top: top - wh2, bottom: bottom };

    this.htmlLast = $('html').outerHeight(true) - _size.h - 10;
  }

  onScroll(_st) {
    super.onScroll();

    if (!this.target || !this.isImageLoadEnd || (Util.isSpModalOpen && !this.isModalIn) || this.target.is(':hidden')) { return; }
    this.scrollTop = _st;
    if ((_st >= this.offset.top && _st <= this.offset.bottom) || (_st >= this.htmlLast && _st < this.offset.top)) {
      if (!this.isStart && this.isLoad) {
        this.isStart = true;
        if (this.isInsertActive) { this.onStart(); }
      }
      if (!this.isActive && this.isLoad) {
        this.isActive = true;
        if (this.isInsertActive) { this.onActive(); }
      }
    } else {
      if (this.isStart && this.isLoad) {
        this.isStart = false;
        if (this.isInsertActive) { this.onStop(); }
      }
    }
  }

  onActive() {
    // console.log(this.name,"onActive");
  }

  onStart() {
    // console.log(this.name,"onStart");
  }
}
